import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * 鎖定媒體的遮罩層（單一媒體用）：黑色 20% 遮罩 ＋ 右上角媒體類型 icon。
 *
 * 鎖定狀態不顯示影片播放鍵（那只存在於未鎖定的 VideoGallery），
 * 「這是影片」由右上角的 icon 表達 —— 貼文與偶像頁媒體 tab 統一這個規則。
 *
 * 只負責疊在模糊圖之上的視覺，不含模糊圖本身、也不含解鎖按鈕：
 * - 模糊圖的尺寸邏輯各處差很多（貼文單圖 contain／多圖 cover／媒體 grid 正方形），由呼叫端自己畫
 * - 解鎖按鈕見 UnlockButton（貼文壓在整組媒體中央，媒體 grid 每格各一顆）
 *
 * 呼叫端需自備 position-relative 容器。客製樣式見 custom.scss 的 .locked-media-*。
 */
const LockedMediaMask = ({ mediaType }) => (
  <>
    <div className="locked-media-mask position-absolute top-0 start-0 w-100 h-100" />
    <div className="locked-media-icon position-absolute text-white">
      <FontAwesomeIcon icon={['fas', mediaType === 1 ? 'video' : 'image']} size="lg" />
    </div>
  </>
);

export default LockedMediaMask;
